import FusionCharts from 'fusioncharts';
import charts from 'fusioncharts/fusioncharts.charts';
import maps from 'fusioncharts/fusioncharts.maps';
import ausMap from 'fusionmaps/maps/fusioncharts.australia';
import radarChart from 'fusioncharts/fusioncharts.powercharts';
import widgets from 'fusioncharts/fusioncharts.widgets';
import {black, blue, blueTranslucent, green, grey, greyShade, red, white} from '../styles/colorCharts';

widgets(FusionCharts);
charts(FusionCharts);
radarChart(FusionCharts);
maps(FusionCharts);
ausMap(FusionCharts);
FusionCharts.options.creditLabel = false;

export function realTimeLineChart(DivId, timestamps, chartData, threshold, valueShouldBeLess) {
    return new Promise((resolve, reject) => {
        FusionCharts.ready(function () {
            let realTimeAreaChart = new FusionCharts({
                id: `${DivId}-chartId`,
                type: 'realtimeline',
                renderAt: DivId,
                width: '100%',
                height: '200',
                dataFormat: 'json',
                dataSource: {
                    "chart": {
                        plotGradientColor: '',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: black,
                        alternateHGridAlpha: '0',
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        showRealTimeValue: '0',
                        showValues: "0",
                        setAdaptiveYMin: '1',
                        numDisplaySets: '20'
                    },
                    // "categories": [
                    //     {
                    //         "category": timestamps
                    //     }
                    // ],
                    "dataset": [
                        {
                            "data": []
                        }
                    ],
                },
            });

            realTimeAreaChart.render(DivId, undefined, () => {
                // Add data
                let colors = [];
                timestamps.forEach((item, index) => {
                    let color = blue;
                    if (threshold) {
                        if (valueShouldBeLess) {
                            color = chartData[index] < threshold ? blue : red;
                        } else {
                            color = chartData[index] > threshold ? blue : red;
                        }
                    }
                    colors.push(color);
                });
                let strData = `&color=${colors.join(',')}&label=${timestamps.join(',')}&value=${chartData.join(',')}`;
                realTimeAreaChart.feedData(strData);
                resolve(realTimeAreaChart);
            });

        });
    });
}

export function updateRealTimeLineChart(DivId, timestamp, value, thresholdCrossed) {
    const chartRef = FusionCharts(`${DivId}-chartId`);

    // Build Data String in format &label=...&value=...
    let color = thresholdCrossed ? red : blue;

    let strData = `&color=${color}&label=${timestamp}&value=${value}`;
    // Feed it to chart.
    chartRef.feedData(strData);
}

export function australiaFusionChartManager(id, type, data) {

    const promiseForAustraliaFusion = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type,
                renderAt: id,
                dataFormat: 'json',
                showBorder: 0,
                width: '100%',
                height: '100%',
                plotHoverEffect: 1,
                plotBorderHoverColor: blue,
                hoverColor: blue,
                plotFillHoverColor: blue,
                dataSource: {
                    chart: {
                        theme: 'fint',
                        showLabels: 1,
                        includeValueInLabels: 1,
                        formatNumberScale: 0,
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                    },
                    data,
                },
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForAustraliaFusion;
}

export function displayDialCharts(id, value, isZAxis, bgColor) {
    let gaugeStartAngle,
        gaugeEndAngle,
        lowerLimit,
        upperLimit,
        valueX,
        valueY;
    if (isZAxis) {
        gaugeStartAngle = 90;
        gaugeEndAngle = -90;
        lowerLimit = 0;
        upperLimit = 180;
        valueX = 120;
        valueY = 160;
    }
    else {
        gaugeStartAngle = 180;
        gaugeEndAngle = 0;
        lowerLimit = -90;
        upperLimit = 90;
        valueX = 160;
        valueY = 190;
    }

    const chartConfig = {
        manageresize: '1',
        origw: '320',
        origh: '320',
        tickvaluedistance: '-10',
        upperlimit: upperLimit,
        lowerlimit: lowerLimit,
        basefontcolor: black,
        majortmcolor: black,
        majortmheight: '5',
        majortmthickness: '2',
        minortmcolor: black,
        minortmheight: '2',
        minortmthickness: '1',
        pivotradius: '10',
        pivotbgcolor: blueTranslucent,
        pivotbordercolor: blue,
        pivotborderthickness: '2',
        tooltipbgcolor: black,
        gaugeouterradius: '115',
        gaugestartangle: gaugeStartAngle,
        gaugeendangle: gaugeEndAngle,
        decimals: '1',
        placevaluesinside: '1',
        pivotfillmix: '',
        showpivotborder: '1',
        annrenderdelay: '0',
        gaugeoriginx: '160',
        gaugeoriginy: '160',
        showborder: '0',
        showValue: '0',
        valueBelowPivot: '1',
        bgColor,
        bgAlpha: '100',
        valueFontBold: '1',
        baseFontColor: white,
        majorTMColor: white,
        minorTMColor: white,
    };

    const dialConfig = {
        dial: [
            {
                value,
                bgcolor: blueTranslucent,
                bordercolor: blue,
                valuey: valueY,
                valuex: valueX,
            },
        ],
    };

    const annotationConfig = {
        groups: [
            {
                x: '160',
                y: '160',
                items: [
                    {
                        type: 'circle',
                        radius: '130',
                        fillcolor: bgColor,
                        fillalpha: '100',
                        showborder: '1',
                        bordercolor: blue,
                        borderThickness: '5',
                    },
                ],
            },
        ],
    };

    let dimension = document.getElementById('MAChartsDiv').offsetHeight;
    dimension *= .27;

    let chart = FusionCharts(`${id}-chartId`);
    if (chart) {
        chart.setJSONData({
            chart: chartConfig,
            dials: dialConfig,
            annotations: annotationConfig,
        });
        chart.resizeTo(dimension, dimension);
    } else {
        chart = new FusionCharts({
            id: `${id}-chartId`,
            type: 'angulargauge',
            width: dimension,
            renderAt: id,
            height: dimension,
            dataFormat: 'json',
            dataSource: {
                chart: chartConfig,
                dials: dialConfig,
                annotations: annotationConfig,
            },
        });
        chart.render();
    }
}

export function doughnutFusionChartManager(id, title, data, label, widthByTwo) {
    const promiseForDoughnutFusion = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type: 'doughnut2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        caption: title,
                        paletteColors: `${grey},${blue}`,
                        use3DLighting: '0',
                        animateClockwise: 1,
                        showShadow: '0',
                        enableSmartLabels: '1',
                        startingAngle: '0',
                        showLabels: '0',
                        showPercentValues: '0',
                        legendShadow: '0',
                        legendBorderAlpha: '0',
                        defaultCenterLabel: data[1].value.toString(),
                        centerLabel: '',
                        centerLabelBold: '0',
                        showTooltip: '1',
                        showPercentInTooltip: 0,
                        decimals: '0',
                        enableRotation: '0',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        baseFontSize: '12', // 15
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        showValues: 0,
                        showLegend: 1,
                        legendBgAlpha: '0'
                    },
                    data,
                    annotations: {
                        // "origw": "400",
                        // "origh": "190",
                        autoscale: '1',
                        groups: [{
                            id: 'range',
                            items: [{
                                id: '',
                                type: 'text',
                                font: 'aguda_boldregular',
                                fontSize: '12', // 16
                                fillcolor: white,
                                text: label,
                                x: widthByTwo,
                                y: '$canvasHeight -30',
                            }],
                        }],
                    },
                },
            });

            fusionCharts.render();
            resolve(fusionCharts)
        });
    });

    return promiseForDoughnutFusion;
}

export function dualYCombination(id, categories, dataset) {
    const promiseForDualY = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusioncharts = new FusionCharts({
                id: `${id}-chartId`,
                type: 'mscombidy2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        plotGradientColor: '',
                        sYAxisMaxValue: '50',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: black,
                        alternateHGridAlpha: '0',
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                    },
                    categories,
                    dataset,
                },
            });
            fusioncharts.render();

            resolve(fusioncharts);

        });
    });

    return promiseForDualY;

}

export function dualLineCombination(id, categories, dataset) {

    const promiseForDualLine = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusioncharts = new FusionCharts({
                id: `${id}-chartId`,
                type: 'msline',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        plotGradientColor: '',
                        sYAxisMaxValue: '50',
                        theme: 'fint',
                        canvasBgAlpha: '0',
                        alternateHGridColor: black,
                        alternateHGridAlpha: '0',
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        showYAxisValues: '0',
                        plotSpacePercent: '65',
                    },
                    categories,
                    dataset,
                },
            });
            fusioncharts.render();

            resolve(fusioncharts);
        });
    });

    return promiseForDualLine;
}

export function bubbleChartFusionCharts(id) {

    const promiseForBubbleChart = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const conversionChart = new FusionCharts({
                id: `${id}-chartId`,
                type: 'bubble',
                renderAt: id,
                width: '100%',
                height: '213',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        xAxisMinValue: '0',
                        xAxisMaxValue: '100',
                        yAxisMinValue: '0',
                        yAxisMaxValue: '30000',
                        plotFillAlpha: '100',
                        plotFillHoverColor: green,
                        showPlotBorder: '0',
                        xAxisName: 'Effort',
                        yAxisName: '',
                        showTrendlineLabels: '0',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        showValues: '0',
                        showAlternateHGridColor: '0',
                        showLegend: '1',
                        legendItemFontColor: black,
                        toolTipBgColor: black,
                        showYAxisValues: '0',
                        trendValueAlpha: '0',
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [
                            {
                                id: 'user-images',
                                items: [
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: white,
                                        fontsize: '11',
                                        text: 'Low',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '350',
                                        x: '$canvasStartX',
                                        y: '$dataset.0.set.4.ENDY',
                                    },
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: white,
                                        fontsize: '11',
                                        text: 'Med',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '350',
                                        x: '$canvasStartX',
                                        y: '$dataset.0.set.3.STARTY',
                                    },
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: white,
                                        fontsize: '11',
                                        text: 'High',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '350',
                                        x: '$canvasStartX',
                                        y: '$canvasStartY + 20',
                                    },
                                    {
                                        type: 'text',
                                        fillcolor: white,
                                        fontsize: '11',
                                        text: 'value',
                                        bold: '1',
                                        x: '$canvasStartX',
                                        y: '$canvasStartY - 10',
                                    },
                                ],
                            },
                        ],
                    },
                    categories: [{
                        category: [{
                            label: '0',
                            x: '0',
                        }, {
                            label: 'Low',
                            x: '20',
                        }, {
                            label: 'Med',
                            x: '50',
                        }, {
                            label: 'High',
                            x: '80',
                        }],
                    }],
                    dataset: [{
                        color: '#92d050',
                        data: [{
                            x: '80',
                            y: '15000',
                            z: '24',
                        }, {
                            x: '60',
                            y: '18500',
                            z: '26',
                        }, {
                            x: '50',
                            y: '19450',
                            z: '19',
                        }, {
                            x: '65',
                            y: '10500',
                            z: '8',
                        }, {
                            x: '43',
                            y: '8750',
                            z: '5',
                        }, {
                            x: '32',
                            y: '22000',
                            z: '10',
                        }, {
                            x: '44',
                            y: '13000',
                            z: '9',
                        }],
                    }],
                    trendlines: [{

                        line: [{
                            displayValue: ' ',
                            startValue: '20000',
                            endValue: '30000',
                            isTrendZone: '1',
                            color: '#142060',
                            alpha: '100',
                        }, {
                            displayValue: ' ',
                            startValue: '10000',
                            endValue: '20000',
                            isTrendZone: '1',
                            color: '#4eb0eb',
                            alpha: '100',
                        }, {
                            displayValue: ' ',
                            startValue: '0',
                            endValue: '10000',
                            isTrendZone: '1',
                            color: '#bdd7ee',
                            alpha: '100',
                        },
                        ],
                    }],
                },
            });
            conversionChart.render();
            resolve();
        });
    });

    return promiseForBubbleChart;
}

export function heatMapFusionChart(id, dataset) {

    const promiseForHeatMap = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const salesHMChart = new FusionCharts({
                id: `${id}-chartId`,
                type: 'heatmap',
                renderAt: id,
                width: '100%',
                height: '560',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        showplotborder: '1',
                        xAxisLabelsOnTop: '1',
                        plottooltext: "<div id='nameDiv' style='font-size: 12px; border-bottom: 1px dashed #666666; font-weight:bold; padding-bottom: 3px; margin-bottom: 5px; display: inline-block; color: #888888;' >$rowLabel :</div>{br}Rating : <b>$dataValue</b>{br}$columnLabel : <b>$tlLabel</b>{br}<b>$trLabel</b>",
                        baseFont: 'Helvetica Neue,Arial',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        showShadow: '100',
                        usePlotGradientColor: '0',
                        canvasBgColor: greyShade,
                        canvasBorderAlpha: '0',
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                        legendShadow: '0',
                        legendItemFontSize: '10',
                        toolTipColor: white,
                        toolTipBorderThickness: '0',
                        toolTipBgAlpha: '80',
                        toolTipBorderRadius: '2',
                        toolTipPadding: '5',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        showValues: '0',
                        gradient: '1',

                    },
                    dataset,
                    colorrange: {
                        gradient: '1',
                        minvalue: '0',
                        code: '#b4c7e7',
                        startlabel: 'Low Correlation',
                        endlabel: 'High Correlation',
                        color: [
                            {
                                code: 'b4c7e7',
                                minvalue: '1',
                                maxvalue: '5',
                            },
                            {
                                code: '4fb0f0',
                                minvalue: '5',
                                maxvalue: '7',
                            },
                            {
                                code: '3870c0',
                                minvalue: '7',
                                maxvalue: '9',
                            },
                            {
                                code: '142060',
                                minvalue: '9',
                                maxvalue: '10',
                            },
                        ],
                    },
                },
            });
            salesHMChart.render();
            resolve();
        });
    });

    return promiseForHeatMap;
}

export function fusionChartManager(id, type, data, title) {
    let height = '290';
    if ((id === 'deviceNotificationBreakdown') && $(window).height() < 768) {
        height = 250;
    }

    const promiseForFusionChart = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type,
                renderAt: id,
                dataFormat: 'json',
                showBorder: 0,
                width: '100%',
                height,
                plotHoverEffect: 1,
                plotBorderHoverColor: blue,
                hoverColor: blue,
                dataSource: {
                    chart: {
                        caption: title,
                        plotGradientColor: '',
                        theme: 'fint',
                        showLabels: 1,
                        includeValueInLabels: 0,
                        formatNumberScale: 0,
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        alternateVGridAlpha: '0',
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                    },
                    data,
                },
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForFusionChart;
}

export function stackedChart(id, dataset, categories, height, colorx) {
    const promiseForHorizontal = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                type: 'stackedbar2d',
                renderAt: id,
                width: '100%',
                height,
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        fontColor: white,
                        baseFontColor: white,
                        legendItemFontColor: black,
                        toolTipBgColor: black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0,
                        theme: "fint",
                        showHoverEffect: "1",
                        usePlotGradientColor: "0",
                        stack100Percent: "0",
                        showLegend: "0",
                        paletteColors: `${green},${red}`,
                        showCanvasBorder: "0",
                        xAxisLineColor: colorx,
                        divlineColor: colorx,
                        divLineIsDashed: "0",
                    },
                    categories,
                    dataset,
                }
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });
    return promiseForHorizontal;
}

export function horizontalLed(id, lHSMin, lHSMax, rHSMin, rHSMax) {
    const promiseForHorizontal = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type: 'hled',
                renderAt: id,
                width: '90%',
                height: '80',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        ledGap: '0',
                        lowerLimit: '0',
                        upperLimit: '100',
                        lowerLimitDisplay: ' ',
                        upperLimitDisplay: ' ',
                        showTickMarks: '0',
                        showTickValues: '1',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        fontColor: white,
                        baseFontColor: white,
                        legendItemFontColor: black,
                        toolTipBgColor: black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0,
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [
                            {
                                id: 'user-images',
                                showBelow: '0',
                                items: [{
                                    id: 'dyn-label',
                                    type: 'text',
                                    fillcolor: white,
                                    fontsize: '11',
                                    text: '',
                                    bold: '1',
                                    wrap: '1',
                                    wrapWidth: '70',
                                    x: '$gaugeStartX+40',
                                    y: '$canvasStartY + 166',
                                },
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: white,
                                        fontsize: '11',
                                        text: '',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '70',
                                        x: '$gaugeEndX-40',
                                        y: '$canvasStartY + 166',
                                    },
                                ],
                            },
                        ],
                    },
                    colorrange: {
                        color: [
                            {
                                minvalue: lHSMin,
                                maxvalue: lHSMax,
                                label: 'Residential',
                                code: blue,
                            },
                            {
                                minvalue: rHSMin,
                                maxvalue: rHSMax,
                                label: 'Business',
                                code: grey,
                            },
                        ],
                    },
                    value: lHSMax,
                },
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForHorizontal;
}

export function horizontalLed2(id, chartId, upperLimit, lowerLimit, value) {
    const promiseForHorizontalLed2 = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                type: 'hled',
                renderAt: id, // unique div it, where to render at
                id: `${id}-chartId`, // should be unique
                width: '90%',
                height: '80',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        ledGap: '0',
                        // Hiding tick marks and values
                        lowerLimit: '0',
                        upperLimit: '100',
                        lowerLimitDisplay: upperLimit,
                        upperLimitDisplay: lowerLimit,
                        showTickMarks: '0',
                        showTickValues: '1',
                        theme: 'fint',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        fontColor: white,
                        baseFontColor: white,
                        legendItemFontColor: black,
                        toolTipBgColor: black,
                        tickMarkDistance: '50',
                        numberSuffix: '%',
                        showValue: 0,
                        chartLeftMargin: 0,
                        chartRightMargin: 0,
                        baseFontSize: '8'
                    },
                    colorrange: {
                        color: [{
                            minvalue: '0',
                            maxvalue: value,
                            label: ' ',
                            code: blue,
                        },
                            {
                                minvalue: value + 1,
                                maxvalue: '100',
                                label: ' ',
                                code: grey,
                            },
                        ],
                    },
                    value,
                },
            });
            fusionCharts.render();

            resolve(fusionCharts);
        });
    });

    return promiseForHorizontalLed2;
}


export function pieChartManager(id, data) {
    const promiseForPieChartManager = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type: 'pie2d',
                renderAt: id,
                width: '100%',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        formatnumberscale: '0',
                        showPercentValues: '0',
                        showPercentInTooltip: '0',
                        baseFontSize: '8',
                        placeValuesInside: '1',
                        showpercentvalues: '1',
                        showLegend: '1',
                        pieRadius: '80',
                        enableSmartLabels: '0',
                        ChartNoDataText: 'Data unavailable',
                        enableMultiSlicing: '0',
                        theme: 'fint',
                        palettecolors: '#006EAB,#70ACE2,#4c6c9c,#6f8db9,#9db1cf,#c3cfe1,#dfe5ef,#c0c0c0,#d6d7d9,#eaeaea',
                        decimals: '1',
                        forcedecimals: '1',
                        enableSlicing: '0',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        showLabels: 1,
                        includeValueInLabels: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendPosition: 'BOTTOM',
                        legendBorderColor: '000000',
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                    },
                    data,
                },
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForPieChartManager;
}

export function msAreaChartFusionChart(id,
                                       categories,
                                       shapeAnnotationXCordinate,
                                       shapeAnnotationXCordinateScore,
                                       shapeAnnotationXCordinateText,
                                       propensityText,) {

    const promiseForMSAreaChart = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            new FusionCharts({
                type: 'msarea',
                id: `${id}-chartId`,
                renderAt: id,
                width: '95%',
                height: '200',
                dataFormat: 'json',
                dataSource: {
                    chart: {
                        yAxisName: '# of Records',
                        paletteColors: '#d9d9d9,#b4c7e7,#4fb0f0',
                        showCanvasBorder: '0',
                        plotBorderAlpha: '10',
                        usePlotGradientColor: '0',
                        legendBorderAlpha: '0',
                        legendShadow: '0',
                        plotFillAlpha: '60',
                        showXAxisLine: '1',
                        axisLineAlpha: '25',
                        showValues: '0',
                        captionFontSize: '14',
                        subcaptionFontSize: '14',
                        subcaptionFontBold: '0',
                        divlineColor: '#999999',
                        divLineIsDashed: '1',
                        divLineDashLen: '1',
                        divLineGapLen: '1',
                        showAlternateHGridColor: '0',
                        toolTipColor: '#ffffff',
                        toolTipBorderThickness: '0',
                        toolTipBgAlpha: '80',
                        toolTipBorderRadius: '2',
                        toolTipPadding: '5',
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        baseFontColor: '#FFFFFF',
                        showYAxisValues: '0',
                        showXAxisValues: '0',
                        legendItemFontColor: '#000000',
                        toolTipBgColor: '#000000',
                        showLegend: '0',
                    },
                    annotations: {
                        width: '5',
                        height: '5',
                        autoScale: '1',
                        groups: [
                            {
                                id: 'user-images',
                                items: [
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: '#ffffff',
                                        fontsize: '7',
                                        text: 'Prediction Not Likely (0)',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '350',
                                        x: '$canvasStartX + 25',
                                        y: '$canvasHeight +20',
                                    },
                                    {
                                        id: 'dyn-label',
                                        type: 'text',
                                        fillcolor: '#ffffff',
                                        fontsize: '7',
                                        text: 'Prediction Likely (1)',
                                        bold: '1',
                                        wrap: '1',
                                        wrapWidth: '350',
                                        x: '$canvasEndX - 25',
                                        y: '$canvasHeight + 20',
                                    },
                                    {

                                        type: 'circle',
                                        x: shapeAnnotationXCordinate,
                                        y: '50',
                                        radius: '10',
                                        color: '#92d050',
                                        text: 'Test',
                                    },
                                    {
                                        type: 'text',
                                        text: 'Propensity Score',
                                        x: shapeAnnotationXCordinateScore,
                                        y: '50',
                                        color: '#92d050',
                                    },
                                    {
                                        type: 'text',
                                        text: propensityText,
                                        x: shapeAnnotationXCordinateText,
                                        y: '50',
                                        color: '#92d050',
                                        fontSize: '20',
                                    },
                                ],
                            },
                        ],
                    },

                    categories,

                    dataset: [
                        {
                            seriesname: 'Previous Week',
                            data: [
                                {
                                    value: '33000',
                                },
                                {
                                    value: '40000',
                                },
                                {
                                    value: '30000',
                                },
                                {
                                    value: '34000',
                                },
                                {
                                    value: '15000',
                                },
                                {
                                    value: '20000',
                                },
                                {
                                    value: '17300',
                                },
                                {
                                    value: '0',
                                },
                            ],
                        },
                        {
                            seriesname: 'Current Week',
                            data: [
                                {
                                    value: '8400',
                                },
                                {
                                    value: '9800',
                                },
                                {
                                    value: '7800',
                                },
                                {
                                    value: '6400',
                                },
                                {
                                    value: '3800',
                                },
                                {
                                    value: '4800',
                                },
                                {
                                    value: '2000',
                                },
                                {
                                    value: '0',
                                },
                            ],
                        },
                        {
                            seriesname: 'test',
                            data: [
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '',
                                },
                                {
                                    value: '0',
                                },
                                {
                                    value: '10000',
                                },
                                {
                                    value: '13000',
                                },
                                {
                                    value: '11000',
                                },
                                {
                                    value: '15000',
                                },
                                {
                                    value: '12000',
                                },
                                {
                                    value: '16000',
                                },
                            ],
                        },
                    ],
                },
            })
                .render();
            resolve();
        });
    });

    return promiseForMSAreaChart;
}

export function radarFusionChartManager(id, type, categories, dataset) {

    const promiseForRadarFusionChart = new Promise((resolve, reject) => {
        FusionCharts.ready(() => {
            const fusionCharts = new FusionCharts({
                id: `${id}-chartId`,
                type,
                renderAt: id,
                dataFormat: 'json',
                width: '100%',
                dataSource: {
                    chart: {
                        numberPreffix: '$',
                        theme: 'fint',
                        radarfillcolor: white,
                        canvasBgAlpha: 0,
                        bgColor: greyShade,
                        bgAlpha: '100',
                        showBorder: 0,
                        animation: 1,
                        showLegend: 1,
                        baseFontColor: white,
                        toolTipBgColor: black,
                        legendItemFontColor: white,
                        legendBgAlpha: '0',
                        legendBorderAlpha: '0',
                    },
                    categories,
                    dataset,
                },
            });
            fusionCharts.render();
            resolve(fusionCharts);
        });
    });

    return promiseForRadarFusionChart;
}

// TODO: all references not changed based on new implementation.
export function disposeChart(id) {
    let chart = FusionCharts(`${id}-chartId`);
    if (chart) {
        chart.dispose();
    }
}



// WEBPACK FOOTER //
// ./util/fusionChartManager.js